import React, { useMemo } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";

export default function VibePieChart({ options = [], totalVotes = 0, compact = false }) {
  const data = useMemo(
    () => options.map((o) => ({ name: o.name, value: o.votes || 0, color: o.color })),
    [options]
  );

  if (!totalVotes) {
    return (
      <div
        className="flex h-56 flex-col items-center justify-center rounded-2xl border border-dashed p-6 text-center"
        style={{ borderColor: "rgba(139,92,246,0.35)", background: "rgba(139,92,246,0.05)" }}
        data-testid="vibe-empty-state"
      >
        <div className="mb-2 text-4xl">🎧</div>
        <p className="text-base font-semibold text-white">No votes yet — be the first!</p>
        <p className="mt-1 text-sm text-slate-400">Pick a vibe to light up the room.</p>
      </div>
    );
  }

  return (
    <div className="w-full" data-testid="vibe-pie-chart">
      <ResponsiveContainer width="100%" height={compact ? 220 : 280}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={compact ? 50 : 60}
            outerRadius={compact ? 85 : 105}
            paddingAngle={3}
            stroke="#0B0E14"
            strokeWidth={3}
          >
            {data.map((d, i) => (
              <Cell key={i} fill={d.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              background: "#131822",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 12,
              color: "#F8FAFC",
            }}
            formatter={(v, n) => [`${v} vote${v === 1 ? "" : "s"}`, n]}
          />
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            wrapperStyle={{ color: "#94A3B8", fontSize: 12, paddingTop: 8 }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
